export const random = (arr) => arr[~~(Math.random() * arr.length)]
